import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Row } from 'react-bootstrap';
import { generateCalloutComponents } from 'helpers/componentGenerators';
import ObjectiveVisibilityContainer from 'containers/dashboards/social/ObjectiveVisibilityContainer';
import GenericSocialExpandContainer from 'containers/dashboards/social/GenericSocialExpandContainer';
import { validateCalloutData } from 'helpers/validate';
import { LAYERTHREE } from 'constants/layers';

const calloutSettings = [
    {
        key: 'impressions',
        title: 'Impressions',
        format: '0,0'
    },
    {
        key: 'mobile_app_installs',
        title: 'App Installs',
        format: '0,0'
    },
    {
        key: 'conversions',
        title: 'Conversions',
        format: '0,0',
        validation: {
            fxn: validateCalloutData,
            passedArgs: { threshold: 0 }
        }
    }
];

class AppInstallsModule extends Component {
    render() {
        const { objective, layer = LAYERTHREE } = this.props;
        const stub = `l${layer}-social`;
        const { actions, callouts, campaigns } = this.props.module;
        const hasCalloutData = get(callouts, 'params.hasData', false);
        const calloutWindow = get(callouts, 'params.timeRanges.previous.windowSize', false);
        const completeData = get(callouts, 'params.completeData', false);
        const calloutsData = hasCalloutData ? callouts.data : {};

        const calloutComponents = generateCalloutComponents({
            stub,
            calloutSettings,
            hasCalloutData,
            callouts: {
                ...calloutsData, completeData
            },
            calloutWindow
        });

        return (
            <ObjectiveVisibilityContainer
                objective={objective}
                actions={actions}
                layer={layer}
                campaigns={campaigns}
                expandContainer={GenericSocialExpandContainer} >
                {/* Call Outs */}
                <Row>
                    {calloutComponents}
                </Row>

            </ObjectiveVisibilityContainer>
        );
    }
}

AppInstallsModule.propTypes = {
    module: PropTypes.shape({
        callouts: PropTypes.object,
    }).isRequired
};

export default AppInstallsModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/AppInstallsModule.js